<template>
    <div>
      <trademark-objection-to-us-yidk-status-list></trademark-objection-to-us-yidk-status-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  